import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-purple-600 to-indigo-600 flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <motion.div
          animate={{ 
            scale: [1, 1.2, 1],
            rotate: [0, 360]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="w-20 h-20 mx-auto mb-4"
        >
          <Brain className="w-full h-full text-white" />
        </motion.div>
        <h2 className="text-2xl font-bold text-white">
          Ładowanie...
        </h2>
      </motion.div>
    </div>
  );
}
